<ng-container *ngIf="!loadingDetectedCase && !discardLoading && !showUpSellingModal && !discardCaseView">
  <article #createCaseContainer class="tw-flex tw-flex-col tw-relative tw-px-8 tw-pt-8 tw-pb-7 tw-overflow-y-auto tw-max-h-[80vh]">
    <section class="tw-flex tw-items-center tw-gap-2 tw-mb-6" *ngIf="(data?.item?.answer?.detectedCase || data?.item?.detected_cases) && showDetectedCases">
      <img src="https://statics.myhotel.cl/uitls/smart-reply-icon-01.svg" alt="smart-reply-image" />
      <p class="tw-mb-0 tw-font-black">{{ 'cases.commons.case_created_ai' | translate }}<span *ngIf="!this.casesLimit.unlimited"> - {{(casesLimit.manual + casesLimit.assisted) + 1 }}/{{ casesLimit.monthly_limit }}</span></p>
    </section>
    <div class="tw-flex tw-flex-col">
      <div *ngIf="item" class="tw-mb-4">
        <section *ngIf="isFromProduct && item">
          <mh-core-lib-product-for-case
            [item]="item"
            [type]="data?.associated"
            [language]="currentLanguage"
            [product]="data?.product"
            [createCase]="'true'"
            [source]="'create'"
          ></mh-core-lib-product-for-case>
        </section>
      </div>

      <form class="tw-w-full tw-flex tw-flex-col" [formGroup]="caseForm" (ngSubmit)="submit()">

        <article class="tw-mb-5">
          <mh-core-lib-text-input
            [ngClass]="{'field-invalid': caseForm.get('title')?.invalid}"
            [placeholder]="'core-lib.input.dialog_cases.title' | translate"
            [keyControl]="'title'"
            [formGroup]="caseForm"
            [maxLength]="maxTitleLength"
            className="tw-font-semibold tw-text-xl !tw-text-black tw-border-gray-400 !tw-font-[Rubik]"
          ></mh-core-lib-text-input>
        </article>

        <article class="tw-mb-3">
          <mh-core-lib-textarea-input
            [ngClass]="{'field-invalid': caseForm.get('description')?.invalid}"
            [placeholder]="'core-lib.input.dialog_cases.description' | translate"
            [keyControl]="'description'"
            [formGroup]="caseForm"
            [withMentions]="true"
            [users]="users"
            [maxLength]="maxDescriptionLength"
            [rows]="6"
            inputClass="!tw-font-[Rubik] tw-border-gray-400"
            (mentionStateChanged)="handleMentionState($event)"
          ></mh-core-lib-textarea-input>
        </article>

        <article class="tw-mb-5">
          <mh-core-lib-file-uploader
            [customerId]="currentCustomerId"
            [uploadedFiles]="caseForm?.get('attachments')?.value || []"
            (filesUploaded)="handleFilesUploaded($event)"
            (uploadingFilesProgress)="uploadingFiles = $event"
            (fileRemoved)="removeUploadedFile($event)"
          ></mh-core-lib-file-uploader>
        </article>

        <article class="tw-mb-5" *ngIf="!isFromProduct">
          <mh-core-lib-autocomplete-input
            class="tw-w-full"
            [options]="onsiteGuests"
            [openBox]="false"
            [filterFn]="autocompleteOnsiteGuestsFilterFn"
            [displayOptionsFn]="displayOnsiteGuestsOptions"
            [placeholder]="'core-lib.input.dialog_cases.guest_or_room' | translate"
            [showIcon]="false"
            customClassInput="!tw-pl-5 !tw-font-[Rubik] placeholder:!tw-text-main-small tw-border-gray-400"
            customClassBox="tw-absolute tw-z-10"
            customClassOptions="tw-font-[Rubik] tw-font-normal tw-text-base tw-text-black"
            (optionSelected)="handleGuestOrRoomOption($event)"
          ></mh-core-lib-autocomplete-input>
        </article>

        <article class="tw-mb-5 ">
          <div class="tw-flex">
            <mh-core-lib-autocomplete-input
              class="tw-w-full"
              [ngClass]="{'field-invalid': caseForm.get('assigned')?.invalid}"
              [options]="assignOptions"
              [openBox]="data?.item?.answer?.detectedCase || data?.item?.detected_cases"
              [filterFn]="assignSelected === 'person' ? autocompleteFilterFn : autocompleteTeamsFilterFn"
              [displayOptionsFn]="assignSelected === 'person' ? displayUsersOptions : displayTeamsOptions"
              [placeholder]="'core-lib.input.dialog_cases.assign_to' | translate"
              [showIcon]="false"
              [clearControl]="clearAssignedAutocompleteControl"
              customClassInput="!tw-pl-5 !tw-font-[Rubik] tw-rounded-tr-none tw-rounded-br-none placeholder:!tw-text-main-small tw-border-gray-400 !tw-min-w-fit"
              customClassBox="tw-absolute tw-z-10"
              customClassOptions="tw-font-[Rubik] tw-font-normal tw-text-base tw-text-black"
              (optionSelected)="handleAssignOption($event)"
              (writtenText)="handleEmptyAssignInput($event)"
            ></mh-core-lib-autocomplete-input>
            <div
              class="tw-flex tw-justify-between tw-w-[30%] tw-max-h-[2.7rem] tw-flex-none tw-cursor-pointer tw-items-center tw-bg-stone-100 tw-text-gray-400 tw-font-medium tw-rounded-r-lg tw-px-0 sm:tw-px-4 tw-border tw-border-gray-400 tw-border-l-0"
              [ngClass]="{'!tw-border-[#FF2020]': caseForm.get('assigned')?.invalid}"
              (click)="handleAssignSelectorClick()"
              cdkOverlayOrigin
              #trigger="cdkOverlayOrigin"
            >
              <ng-container *ngIf="isMobile; else desktopSelector">
                <div (click)="handleAssignType('person')" [ngClass]="{'tw-bg-sky-100': assignSelected === 'person'}" class="tw-w-full tw-h-full tw-grid tw-content-center tw-justify-center tw-border-r tw-border-gray-400 tw-cursor-pointer">
                  <i class="fal fa-user tw-text-main-blue"></i>
                </div>
                <div (click)="handleAssignType('team')" [ngClass]="{'tw-bg-sky-100': assignSelected === 'team'}" class="tw-w-full tw-h-full tw-grid tw-content-center tw-justify-center tw-cursor-pointer tw-rounded-r-lg">
                  <i class="fal fa-users tw-text-main-blue"></i>
                </div>
              </ng-container>

              <ng-template #desktopSelector>
                <span>{{ 'core-lib.input.dialog_cases.' + assignSelected | translate }}</span>
                <i class="fal fa-chevron-down"></i>
              </ng-template>
            </div>

            <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="trigger"
              [cdkConnectedOverlayOpen]="assignOpen"
              [cdkConnectedOverlayPanelClass]="'!tw-mt-2'"
              (overlayOutsideClick)="assignOpen = false"
            >
              <ul class="tw-bg-stone-100 tw-shadow-1 tw-relative tw-p-3 tw-rounded-r-lg tw-border tw-border-gray-400 tw-w-40">
                <li class="tw-py-1 tw-cursor-pointer" *ngFor="let item of assignTypes" (click)="handleAssignType(item)">
                  <button type="button" class="hover:tw-text-main-orange tw-transition-all focus:tw-outline-0">
                    <span class="tw-font-[Rubik] tw-font-medium tw-text-gray-400">{{ 'core-lib.input.dialog_cases.' + item | translate }}</span>
                  </button>
                </li>
              </ul>
            </ng-template>
          </div>

          <ng-container>
            <p *ngIf="assignSelected === 'team' && assignOptions.length === 0" class="tw-text-red-500 tw-text-center tw-text-sm tw-mt-1">{{ 'cases.create_modal.no_teams' | translate }}</p>
          </ng-container>
        </article>

        <article class="tw-mb-5 tw-flex" formGroupName="time_type">
          <mh-core-lib-text-input
            class="tw-w-full"
            [ngClass]="{'field-invalid': caseForm.get('time_type')?.get('total')?.invalid}"
            [type]="timeSelected !== 'date' ? 'number' : 'date'"
            [minDate]="timeSelected === 'date' ? todayDate : null"
            [placeholder]="('core-lib.input.dialog_cases.time_to_resolve' | translate) + (!flagConditionalExpired ? ' (' + ('commons.optional' | translate) + ')' : '')"
            [formGroup]="caseForm.get('time_type')"
            [keyControl]="'total'"
            className="tw-border-gray-400 tw-rounded-tr-none tw-rounded-br-none !tw-font-[Rubik]"
            [clearControl]="clearTimeAutocompleteControl"
            [onlyNumber]="true"
          ></mh-core-lib-text-input>
          <div
            class="tw-flex tw-justify-between tw-w-[30%] tw-flex-none tw-cursor-pointer tw-items-center tw-bg-stone-100 tw-text-gray-400 tw-font-medium tw-rounded-r-lg tw-px-4 tw-border tw-border-gray-400 tw-border-l-0"
            [ngClass]="{'!tw-border-[#FF2020]': caseForm.get('time_type')?.get('total')?.invalid}"
            (click)="timeOpen = !timeOpen"
            cdkOverlayOrigin
            #timeTrigger="cdkOverlayOrigin"
          >
            <span>{{ 'notifications.central.' + timeSelected | translate }}</span>
            <i class="fal fa-chevron-down"></i>
          </div>

          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="timeTrigger"
            [cdkConnectedOverlayOpen]="timeOpen"
            [cdkConnectedOverlayPanelClass]="'!tw-mt-2'"
            (overlayOutsideClick)="timeOpen = false"
          >
            <ul class="tw-bg-stone-100 tw-shadow-1 tw-relative tw-p-3 tw-rounded-r-lg tw-border tw-border-gray-400 tw-w-40">
              <li class="tw-py-1 tw-cursor-pointer" *ngFor="let item of timeTypes" (click)="handleTimeType(item)">
                <button type="button" class="hover:tw-text-main-orange tw-transition-all focus:tw-outline-0">
                  <span class="tw-font-[Rubik] tw-font-medium tw-text-gray-400">{{ 'notifications.central.' + item | translate }}</span>
                </button>
              </li>
            </ul>
          </ng-template>
        </article>

        <article class="tw-mb-2">
          <mh-core-lib-tag-input
            [options]="areas"
            [displayChipsFn]="displayChipsFn"
            [displayChipsListFn]="displayChipsFn"
            [allSelected]="false"
            [checkedAllOption]="false"
            [showAutocompleteInput]="true"
            [inputTagFilter]="autocompleteTeamsFilterFn"
            [displayCheckInput]="false"
            [inputSelectedOptions]="selectedDetectedAreas ?? []"
            [boxOpen]="false"
            [placeholder]="'core-lib.input.dialog_cases.areas' | translate"
            [customClasses]="'!tw-font-[Rubik] !tw-mb-0'"
            [parentCustomClass]="'tw-border-gray-400 !tw-min-h-0'"
            (optionClicked)="handleAreasInput($event)"
          ></mh-core-lib-tag-input>
        </article>

        <article class="tw-mb-5">
          <mh-core-lib-select-input
            [options]="types"
            [displayFn]="displayFnTypes"
            [placeholder]="'core-lib.input.dialog_cases.type' | translate"
            [keyControl]="'case_type'"
            [formGroup]="caseForm"
            [selectedOption]="detectedCaseData?.case_type ?? null"
            [inputId]="'selectInput-1'"
            [ngClass]="{'field-invalid': caseForm.get('case_type')?.invalid}"
            customClasses="!tw-font-[Rubik] tw-border-gray-400"
            [iconClass]="'fal fa-chevron-down !tw-text-gray-400'"
            (click)="scrollToBottom()"
          ></mh-core-lib-select-input>
        </article>

        <article>
          <mh-core-lib-select-input
            [options]="priorities"
            [displayFn]="displayFnPriorities"
            [placeholder]="'core-lib.input.dialog_cases.priority' | translate"
            [keyControl]="'priority'"
            [formGroup]="caseForm"
            [selectedOption]="detectedCaseData?.priority ?? null"
            [inputId]="'selectInput-2'"
            [ngClass]="{'field-invalid': caseForm.get('priority')?.invalid}"
            customClasses="!tw-font-[Rubik] tw-border-gray-400"
            [iconClass]="'fal fa-chevron-down !tw-text-gray-400'"
            (click)="scrollToBottom()"
          ></mh-core-lib-select-input>
        </article>
      </form>

      <div *ngIf="caseForm.invalid" class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-mt-4">
        <span class="tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-[#FF2020] tw-inline-block tw-flex-shrink-0"></span>
        <span class="tw-font-[Rubik] tw-font-normal tw-text-sm tw-text-[#FF2020] tw-leading-[100%]">
          {{ 'cases.create_modal.complete_required_fields' | translate }}
        </span>
      </div>

    </div>

  </article>

  <article class="tw-shadow-[0px_0px_9px_#d6d5d5] tw-sticky tw-bottom-0 tw-z-50 tw-bg-white tw-w-full tw-border-t tw-border-gray-200">
    <!-- Inline y no snackbar: el modal queda abierto y el texto tiene que seguir a la vista
         mientras el usuario corrige lo que causó el error -->
    <p
      *ngIf="submitErrorKey"
      class="tw-flex tw-items-start tw-gap-2 tw-px-6 tw-pt-3 tw-text-sm tw-text-red-500"
    >
      <i class="fas fa-exclamation-circle tw-mt-[3px]"></i>
      <span>{{ submitErrorKey | translate }}</span>
    </p>
    <section class="tw-flex tw-w-full tw-justify-center tw-gap-5 tw-py-4 tw-mx-auto tw-overflow-hidden">
      <mh-core-lib-button
        [isSecondary]="true"
        [text]="'commons.cancel' | translate"
        [customClass]="'!tw-shadow-none'"
        [textClass]="'tw-font-[Rubik]'"
        (clicked)="close()"
      ></mh-core-lib-button>
      <mh-core-lib-button
        [isSecondary]="true"
        [width]="220"
        [text]="'cases.commons.discard_detected_case' | translate"
        [customClass]="'!tw-shadow-none'"
        [textClass]="'tw-font-[Rubik]'"
        *ngIf="(data?.item?.answer?.detectedCase || data?.item?.detected_cases) && showDetectedCases"
        (clicked)="discardCaseView = true;"
      ></mh-core-lib-button>
      <mh-core-lib-button
        [isPrimary]="true"
        [isDisabled]="caseForm.invalid || uploadingFiles || saving"
        [text]="'cases.titles.form' | translate"
        [customClass]="'!tw-shadow-none'"
        [textClass]="'tw-font-[Rubik]'"
        (clicked)="submit()"
      ></mh-core-lib-button>
    </section>
  </article>
</ng-container>


<section class="tw-p-10" *ngIf="loadingDetectedCase">
    <p class="tw-text-2xl tw-font-bold tw-text-center">{{ 'smart_replies.action_button.loading' | translate }}</p>
    <img
      class="tw-w-1/5 tw-mt-4 tw-mx-auto"
      src="https://statics.myhotel.cl/uploads/fidelity-suite/commons/smart-replies-bot.gif"
    />
</section>

<section class="tw-p-10" *ngIf="discardLoading">
  <mh-core-lib-loader-wrapper
    [type]="'spinner'"
    [loading]="discardLoading"
    className="tw-self-center"
    spinnerClassName="tw-text-[50px]">
  </mh-core-lib-loader-wrapper>
</section>

<section *ngIf="discardCaseView && !discardLoading" class="tw-flex tw-flex-col tw-justify-center tw-items-center">
  <article #createCaseContainer
    class="tw-flex tw-flex-col tw-items-center tw-px-8 tw-pt-8 tw-pb-7 tw-overflow-y-auto tw-max-h-[80vh] tw-bg-white tw-shadow-lg tw-rounded-lg tw-w-full">

    <h3 class="tw-text-[26px] tw-font-bold tw-font-[Rubik] tw-mb-10 tw-text-center">
      {{ 'cases.detail_modal.please_choose_a_reason_to_reject' | translate }}
    </h3>

    <div class="tw-border tw-border-black tw-p-4 tw-mb-10 tw-flex tw-items-center tw-w-full tw-rounded-sm">
      <span class="tw-text-3xl tw-mr-3">⚠️</span>
      <p class="tw-text-left">
        <span class="tw-font-bold">{{ 'cases.detail_modal.myhotel_ia_criteria' | translate }}</span>
        {{ ' ' + detectedCaseData.creation_criteria }}
      </p>
    </div>

    <p class="tw-mb-4 tw-text-center">{{ 'cases.detail_modal.choose_reject_reason' | translate }}</p>

    <div class="tw-w-full" *ngIf="reasons">
      <form [formGroup]="reasonForm" class="tw-flex tw-flex-col tw-gap-4 tw-items-center tw-w-full">
        <ng-container *ngFor="let option of reasons">
            <label class="tw-flex tw-items-center tw-w-3/4 tw-space-x-4 tw-cursor-pointer tw-normal-case tw-select-none">
              <input class="tw-border-2 tw-h-5 tw-w-5 tw-border-[#0F93CC]" type="radio" formControlName="reason"
                [value]="option.id" />
              <span class="tw-font-[Rubik] tw-font-normal tw-text-base">
                {{ option.reason }}
              </span>
            </label>

          <mh-core-lib-textarea-input class="tw-w-3/4" [placeholder]="'cases.detail_modal.insert_reason' | translate"
            [formGroup]="reasonForm" [keyControl]="'reasonComment'" [rows]="5"
            [inputClass]="'!tw-font-[Rubik] tw-border-gray-400 tw-resize-none'"
            [style.visibility]="currentOption !== 5 ? 'hidden' : 'visible'" *ngIf="option?.id === 5">
          </mh-core-lib-textarea-input>
        </ng-container>
      </form>
    </div>
  </article>
  <article class="tw-shadow-[0px_0px_9px_#d6d5d5] tw-sticky tw-bottom-0 tw-z-50 tw-bg-white tw-w-full tw-border-t tw-border-gray-200">
    <div class="tw-flex tw-w-full tw-justify-center tw-gap-5 tw-py-4 tw-mx-auto tw-overflow-hidden">
      <mh-core-lib-button [isSecondary]="true" [text]="'commons.cancel' | translate" [customClass]="'!tw-shadow-none'"
        [textClass]="'tw-font-[Rubik]'" (clicked)="discardCaseView = false">
      </mh-core-lib-button>

      <mh-core-lib-button [isPrimary]="true" [isDisabled]="reasonForm.invalid"
        [text]="'cases.commons.reject' | translate" [customClass]="'!tw-shadow-none'" [textClass]="'tw-font-[Rubik]'"
        (clicked)="discardCase()">
      </mh-core-lib-button>
    </div>
  </article>
</section>

<ng-container *ngIf="showUpSellingModal">
  <div class="tw-w-full tw-py-2 lg:tw-py-3">
    <!-- Content container -->
    <section class="tw-px-5 tw-py-5 tw-text-center tw-overflow-y-auto tw-max-h-[80vh] tw-relative">
      <!-- Image Icon -->
      <img
        src="https://statics.myhotel.cl/uploads/fidelity-suite/cases/THT_M678_02+1.png"
        alt="Desk Module Icon"
        class="tw-mx-auto tw-w-[250px] tw-h-[190px]"
      />

      <!-- Title -->
      <div class="tw-mx-20 tw-text-2xl tw-font-bold tw-my-2 lg:tw-my-4" [innerHTML]="'cases.upsell.title' | translate">
      </div>

      <!-- Features List -->
      <ul class="tw-text-left tw-max-w-md tw-mx-auto tw-space-y-3 tw-text-[#5B5B5B] tw-mb-6 lg:tw-mb-12">
        <li *ngFor="let feature of features" class="tw-flex tw-items-center">
          <i class="fas fa-check-circle tw-text-[#6BC1CC] tw-mr-2"></i
          >{{ 'cases.upsell.' + feature | translate }}
        </li>
      </ul>

      <!-- Action Buttons -->
      <div class="tw-flex tw-justify-center tw-mb-4">
        <mh-core-lib-button
          class="tw-mx-2"
          [width]="250"
          [isPrimary]="true"
          [text]="'cases.upsell.schedule' | translate"
          (clicked)="scheduleDemo()"
        ></mh-core-lib-button>
      </div>

      <!-- Decline Option -->
      <p class="tw-mt-1 tw-text-sm tw-text-black tw-cursor-pointer tw-underline" (click)="onDecline()">
        {{ 'cases.upsell.decline' | translate }}
      </p>
    </section>
  </div>
</ng-container>
